import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '@api/user/Guard';
import { NoAuthGuard } from '@api/guard/no-auth.guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./features')
      .then(m => m.FeaturesModule),
    canActivate: [ AuthGuard],
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./login')
      .then(m => m.LoginModule),
    canActivate: [NoAuthGuard],
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
